import React from "react";
import "./Title.css";

const Title = () => {
  return (
    <div className="title">
      <h1>Stranger's Things</h1>
    </div>
  );
};

export default Title;
